import { Box } from '@mui/material'
import { css } from '@emotion/react'
import { motion } from 'framer-motion'
import styled from '@emotion/styled'

export interface StylesProps {
  isOpen: boolean
  isSelected?: boolean
}

export const MenuBox = styled(Box)<StylesProps>`
  ${({ theme, isSelected, isOpen }) => css`
    height: 48px;
    min-width: 80px;
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.lightest};
    display: flex;
    align-items: center;
    gap: 4px;
    padding-left: ${isOpen ? '16px' : '30px'};
    cursor: pointer;

    svg {
      margin-top: 4px;
      width: ${isOpen ? '14px' : '20px'};
      height: ${isOpen ? '14px' : '20px'};
      color: ${theme.colors.lightest};
    }

    border-radius: 8px;

    ${!!isSelected
      ? css`
          color: ${theme.colors.lightest};
          background: ${theme.colors.myapps.blue[500]};
        `
      : css`
          &:hover {
            transition: all ease-in-out 0.3s;
            background: ${theme.colors.myapps.gray[500]};
          }
        `}

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding-left: 16px;
    }
  `}
`

export const SubMenusBox = styled(Box)`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SubMenuBox = styled(MenuBox)<StylesProps & { depth?: number }>`
  ${({ isOpen, isSelected, theme, depth = 0 }) => css`
    font-size: 14px;
    font-weight: 400;
    padding-left: ${isOpen ? `${40 + depth * 16}px` : '30px'};
    color: ${theme.colors.myapps.menus.subMenu};

    ${!!isSelected
      ? css`
          color: ${theme.colors.lightest};
          background: ${theme.colors.myapps.blue[500]};
        `
      : css`
          &:hover {
            transition: all ease-in-out 0.3s;
            background: ${theme.colors.myapps.gray[500]};
          }
        `};
  `}
`

export const Icon = styled(Box)<Pick<StylesProps, 'isSelected' | 'isOpen'>>`
  ${({ theme, isSelected, isOpen }) => css`
    color: ${isSelected ? theme.colors.lightest : theme.colors.lightest};

    svg {
      margin-top: 4px;
      width: ${isOpen ? '14px' : '20px'};
      height: ${isOpen ? '14px' : '20px'};
      color: ${theme.colors.lightest};
    }
  `}
`

export const MenuText = styled(motion.create(Box))`
  white-space: nowrap;
  line-height: 20px;

  svg {
    margin-top: 4px;
    width: 14px;
    height: 14px;
  }
`

export const ArrowIconBox = styled(Box)`
  margin-left: auto;
  position: absolute;
  right: 24px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const InfoIconBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`
